import { NgModule } from '@angular/core';

import { HasAccessToDirective } from '@permissions/directives/has-access-to.directive';

@NgModule({
  declarations: [HasAccessToDirective],
  exports: [HasAccessToDirective],
})
export class PermissionsModule {}
